import { auth } from "@utils/firebase";
import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet } from "react-router-dom";

type ProtectedAuthPagesProps = {};

const ProtectedAuthPages: React.FC<ProtectedAuthPagesProps> = () => {
  const [user, userLoading] = useAuthState(auth);

  if (userLoading) {
    return <></>;
  } else {
    if (user) {
      return <Navigate to="/" />;
    } else {
      return <Outlet />;
    }
  }
};
export default ProtectedAuthPages;
